import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "CLUB IS CLEAN AND WELL KEPT. GROUP TRAINERS ARE ENTHUSIASTIC, ENGAGING AND WELL PREPARED. I LOVE THAT YOU HAVE ‘MORE MATURE’ TRAINERS... MAKES FOR GREAT ROLE MODELS",
    name: 'JOHN TAMBOLI',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'CONVENIENTLY LOCATED GOOD AESTHETICS PLENTY OF ROOMS ― DOWNSTAIRS, WOMENS ROOM AND CLASSROOM SPACE LOW KEY',
    name: 'THE ROCK',
    status: 'COACH'
  },
  {
    image : image3,
    review:'HIGH QUALITY, DIVERSE GROUP CLASSES; EQUIPMENTS IN GOOD CONDITION; PEOPLE ARE NICE TO ONE ANOTHER LIKE IN A FRIENDLY COMMUNITY',
    name: 'GOLDBERG',
    status: "CUSTOMER"
  }
];
